import React from 'react';
import { Form, Input, Button, Alert, Row, Col, message } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setNewPassword } from '../../../store/user/actions';
import '../../../styles/pages/_newPasswordPage.scss'; 

const NewPasswordPage = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, hasError } = useSelector((state) => state.forms.appConfig);

  const onFinish = (values) => {
    dispatch(setNewPassword(values.password))
      .then(() => {
        message.success('Ο κωδικός πρόσβασης άλλαξε με επιτυχία');
        navigate('/login');
      })
      .catch((error) => {
        message.error('Αποτυχία αλλαγής κωδικού πρόσβασης. Παρακαλώ προσπαθήστε ξανά.');
      });
  };

  const passwordRules = [
    { required: true, message: 'Παρακαλώ εισάγετε τον νέο κωδικό!' },
    { min: 6, message: 'Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες!' },
    {
      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]+$/,
      message:
        'Ο κωδικός πρέπει να περιλαμβάνει κεφαλαία γράμματα, πεζά γράμματα, αριθμούς και ειδικούς χαρακτήρες!',
    },
  ];

  return (
    <div className="newpass-page">
      <Row justify="center" align="middle" className="newpass-title-row">
        <Col span={24} className="newpass-title-col">
          <h2 className="newpass-title">Αλλαγή Κωδικού</h2>
        </Col>
      </Row>

      {hasError && (
        <Row justify="center" className="newpass-error-row">
          <Col span={24} className="newpass-error-col">
            <Alert
              message="Σφάλμα"
              description="Παρουσιάστηκε σφάλμα κατά την αλλαγή του κωδικού πρόσβασης."
              type="error"
              icon={<ExclamationCircleFilled />}
              closable
              showIcon
              className="newpass-error-alert"
            />
          </Col>
        </Row>
      )}

        <Row justify="center" className="newpass-form-row">
        <Col xs={24} sm={20} md={16} lg={12} className="newpass-form-col">
          <Form form={form} onFinish={onFinish} layout="vertical" className="newpass-form">
            <Form.Item
              name="password"
              id='new-pass'
              label="Νέος Κωδικός"
              rules={passwordRules}
              className="newpass-form-item"
            >
              <Input.Password placeholder="Εισάγετε κωδικό" className="newpass-input" />
            </Form.Item>

            <Form.Item
              name="confirmPassword"
              label="Επιβεβαίωση"
              id='confirm'
              dependencies={['password']}
              rules={[
                {
                  required: true,
                  message: 'Παρακαλώ επιβεβαιώστε τον κωδικό σας!',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Οι δύο κωδικοί που εισάγατε δεν ταιριάζουν!'));
                  },
                }),
              ]}
              className="newpass-form-item"
            >
              <Input.Password placeholder="Επιβεβαιώστε τον κωδικό" className="newpass-input" />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                id='confirm-btn'
                htmlType="submit"
                loading={loading}
                className="newpass-submit-button"
              >
                Υποβολή
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default NewPasswordPage;